header.banner {
    padding: 2rem 1rem;
    height: 90vh;
    @media (min-width: 576px) {
        padding: 4rem 2rem;
    }
    background: url(./2020/image/banner.jpg) no-repeat center;
    background-size: cover;
    color: white;
    :global {
        & .container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
    }
    h1 {
        color: var(--bs-warning);
        font-weight: bold;
        & + p {
            font-size: xx-large;
        }
    }
    hr {
        opacity: 0;
    }
}
